/**
 * allQuestIds.js
 * Written by: Alex Kasemir
 */

import uniq from 'lodash.uniq';
import resultActions from '../../actions';
import questionActions from '../../../question/actions';

/**
 * Description of the allQuestIds reducer
 */
const allQuestIds = (state = [], action) => {
  switch (action.type) {
    case questionActions.SUBMIT_QUESTION_SUCCESS:
    case resultActions.GET_RESULT_SUCCESS:
      return uniq([...state, action.id]);
    case resultActions.CLEAR_RESULTS:
      if (action.current) {
        return [action.current];
      }
      return [];
    default:
      return state;
  }
};

export default allQuestIds;
